import { CFHeader } from "./CustomField/CFHeader";

export const headerComponents = {
  cfHeader: CFHeader,
};
